import _ from "lodash";
import { useMemo } from "react";
import usePermit from "./permits/usePermit";
import usePermitType from "./permits/usePermitType";
import usePermitForm from "./permits/usePermitForm";

export function useIsOldPermitType(permitId: string) {
  const permitQuery = usePermit({ permitId: permitId });
  const permitsTypeId = useMemo(() => _.get(permitQuery.data, "data.attributes.permits-type-id"), [permitQuery.data]);
  const permitsTypeQuery = usePermitType({ permitTypeId: permitsTypeId });
  const permitsFormId = useMemo(
    () => _.get(permitsTypeQuery.data, "data.attributes.permits-form-id"),
    [permitsTypeQuery.data],
  );
  const permitsFormQuery = usePermitForm(permitsFormId);
  const usesApplicantSection = useMemo(
    () => _.get(permitsFormQuery.data, "data.attributes.uses-system-generated-applicant-sections"),
    [permitsFormQuery.data],
  );
  const isOldPermitType = !usesApplicantSection;
  const isLoading = permitQuery.isLoading || permitsTypeQuery.isLoading || permitsFormQuery.isLoading;

  return { isLoading, isOldPermitType };
}
